import axios from 'axios'
import {
  User,
  AuthResponse,
  LoginRequest,
  VerifyEmailResponse,
  PasswordResetResponse,
  Verify2FAResponse,
} from '../types'

const API_BASE_URL = import.meta.env.VITE_API_URL || '/api'

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
})

// Add token to requests if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

export const login = async (
  credentials: LoginRequest,
): Promise<AuthResponse> => {
  const response = await api.post('/auth/login', credentials)
  return response.data
}

export const verifyToken = async (token: string): Promise<User> => {
  const response = await api.get('/auth/verify', {
    headers: { Authorization: `Bearer ${token}` },
  })
  return response.data.user
}

export const verifyEmail = async (
  token: string,
): Promise<VerifyEmailResponse> => {
  const response = await api.post('/auth/verify-email', { token })
  return response.data
}

export const resendVerification = async (
  email: string,
): Promise<VerifyEmailResponse> => {
  const response = await api.post('/auth/resend-verification', { email })
  return response.data
}

export const forgotPassword = async (
  email: string,
): Promise<PasswordResetResponse> => {
  const response = await api.post('/auth/forgot-password', { email })
  return response.data
}

export const resetPassword = async (
  token: string,
  password: string,
): Promise<PasswordResetResponse> => {
  const response = await api.post('/auth/reset-password', { token, password })
  return response.data
}

export const verify2FA = async (
  email: string,
  code: string,
): Promise<Verify2FAResponse> => {
  const response = await api.post('/auth/verify-2fa', { email, code })
  return response.data
}
